<template>
    <div class="body-view-day">
        <div class="items-week">
            <div class="left-none">{{ dayCycleStr }}</div>
            <div class="item-week">
                周{{ dayItem.weekday }}
            </div>
        </div>
        <!-- 全天 -->
        <div class="row-day">
            <div class="left-day">全天</div>
            <div class="item-all-day my-cursor" @click.stop="submitDay(dayItem)">
                <div class="item-day-title">
                    <div class="text-day">
                        <template v-if="dayItem.isToday">
                            今
                        </template>
                        <template v-else>
                            {{ dayItem.day }}
                        </template>
                    </div>
                    <div class="text-vice-day" :style="[{'color': dayItem.viceColor}]">{{ dayItem.viceDay }}</div>
                    <div class="text-work-day" v-if="dayItem.isWork === 1">班</div>
                    <div class="text-rest-day" v-else-if="dayItem.isWork === 2">休</div>
                </div>
                <div class="item-day-chain">
                    <div class="chain-row" v-for="(chainItem) in allDayChainItems">
                        <div class="item-matter my-cursor"
                             :style="[{'background': matterItem.color},{'opacity': (matterItem.state === 1 || matterItem.state === 2) ? 0.25:1}]"
                             @click.stop="submitMatter(matterItem)"
                             v-for="(matterItem) in chainItem">
                            {{ matterItem.text}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row-scroll" ref="row-scroll">
            <!-- 上 折叠行 -->
            <div class="row-up-fold-hour" v-if="upFoldIndex > -1">
                <div class="left-hour my-cursor" @click.stop="setUnfoldIndex('upFoldIndex')">
                    00:00<br>
                    <i class="el-icon-arrow-up"></i><br>
                    <i class="el-icon-arrow-down"></i><br>
                    {{hourItems[0].hour}}:00
                </div>
                <!-- 折叠事项 -->
                <div class="item-hour-day">
                    <div class="fold-matter-text"
                         v-if="unFoldItemIndex < 3"
                         v-for="(upFoldItem, unFoldItemIndex) in hourDayChainItem.upFoldItems">
                        {{upFoldItem.title}} {{upFoldItem.time}}
                    </div>
                    <div class="fold-more-text" v-if="hourDayChainItem.upFoldItems.length > 3">
                        +{{ hourDayChainItem.upFoldItems.length - 3 }}
                    </div>
                </div>
            </div>
            <!-- 展示行 -->
            <div class="row-hour-item" v-for="(hourItem) in hourItems">
                <div class="left-hour"
                     :class="{'my-cursor': hourItem.foldAllow}"
                     @mouseover="mouseenter(hourItem.index)" @mouseleave="mouseleave()"
                     @click.stop="setFoldIndex(hourItem.index, hourItem.foldAllow)">
                    <div class="hour-text">
                        {{ hourItem.hour }}:00
                    </div>
                    <!-- 折叠
                        1. 0至十点;
                        2. 14至24点2鼠标划入
                    -->
                    <template v-if="hourItem.foldAllow && mouseHourIndex === hourItem.index">
                        <div class="fold-switch">
                            <i class="el-icon-arrow-down"></i><br>
                            <i class="el-icon-arrow-up"></i>
                        </div>
                    </template>
                </div>
                <div class="item-hour-day">
                    <div class="time-line" :style="[
                            {background: dayItem.isToday? 'rgba(225, 62, 57, 1)': 'rgba(225, 62, 57, 0.2)'},
                            {marginTop: (minuteNumber * 2.358 / 100) + 'rem'}]"
                         v-if="hourItem.index === hourNumber">
                        <div class="time-line-point" v-if="dayItem.isToday"></div>
                        <div class="hour-text-now" >
                            {{ lineTime }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 纵向列表 -->
            <div class="column-items-day"
                 :style="[
                         {height: (3720 - (upFoldIndex+1) * 155 - (24 - downFoldIndex) * 155) / 100 + 'rem'},
                         {marginTop: -(3720 - (upFoldIndex+1) * 155 - (24 - downFoldIndex) * 155) / 100 + 'rem'},
                         ]"
            >
                <div class="column-item-day">

                    <div class="column-chain-item"
                         :style="{width: 'calc(100% / ' + hourDayChainItem.chainItems.length +')'}"
                         v-for="(chainItem) in hourDayChainItem.chainItems">

                        <div class="matter-item"
                             :style="[
                                     {width: matterItem.freeWidth * 100 + '%'},
                                     {height: (matterItem.endHeight - matterItem.startHeight) / 100 + 'rem'},
                                     {marginTop: matterItem.topHeight/100 + 'rem'}]"
                             v-for="(matterItem) in chainItem.chainMatter">
                            <div class="matter-text my-cursor" :style="[
                                    {'background': matterItem.color},
                                    {'opacity': matterItem.clockedStatus === 1 || matterItem.clockedStatus === 2 ? 0.25:1}
                                ]" @click.stop="submitMatter(matterItem)">
                                {{ matterItem.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 下 折叠行 -->
            <div class="row-down-fold-hour" v-if="downFoldIndex < 24">
                <div class="left-hour my-cursor" @click.stop="setUnfoldIndex('downFoldIndex')">
                    {{ parseInt(hourItems[hourItems.length - 1].hour) + 1 }}:00<br>
                    <i class="el-icon-arrow-up"></i><br>
                    <i class="el-icon-arrow-down"></i><br>
                    24:00
                </div>
                <div class="item-hour-day">
                    <div class="fold-matter-text"
                         v-if="downFoldItemIndex < 3"
                         v-for="(downFoldItem, downFoldItemIndex) in hourDayChainItem.downFoldItems">
                        {{downFoldItem.title}} {{downFoldItem.time}}
                    </div>
                    <div class="fold-more-text" v-if="hourDayChainItem.downFoldItems.length > 3">
                        +{{ hourDayChainItem.downFoldItems.length - 3 }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listShowInfo from "@/utils/List/listShowInfo";
import SetChainItems from "@/utils/View/SetChainItems";
import SetChainItemsHour from "@/utils/View/SetChainItemsHour";

export default {
    name: "index",
    data(){
        return {
            dayItem: {},
            dayCycleStr: "",
            todayStr: "",
            selectDayStr: "",
            hourItems: [],
            allDayChainItems: [],
            hourDayChainItem: [],
            upFoldIndex: -1,
            downFoldIndex: 24,
            mouseHourIndex: -1,
            lineTime: "",
            hourNumber: 0,
            minuteNumber: 0,
            intervalId: null,
        }
    },
    methods: {
        getCycleDayItems: function(switchType){
            if(switchType === "prev"){
                this.solarDate = this.solarDate.next(-1)
            }else if(switchType === "next"){
                this.solarDate = this.solarDate.next(1)
            }else if(switchType === "current"){
                this.solarDate = Solar.fromDate(new Date())
            }
            this.selectDayStr = "";
            // 更新周期内事件
            this.updateMatterItem();
        },
        updateMatterItem: function(){
            const itemYmd = this.solarDate.toYmd()
            const viceItem = this.$Utils.getViceDay(this.solarDate);
            const isWork = this.$Utils.checkWork(itemYmd);
            const isToday = itemYmd === this.todayStr;

            let dayItems = [{
                day: this.solarDate.getDay(),
                viceDay: viceItem.viceDay,
                viceColor: viceItem.viceColor,
                isWork: isWork,
                weekday: this.solarDate.getWeekInChinese(),
                isToday: isToday,
                date: itemYmd,
                matterArray: [],
            }]

            listShowInfo.setMonthDays(dayItems);
            this.selectDayStr = itemYmd;
            this.dayCycleStr = this.solarDate.getMonth() + "." + this.solarDate.getDay();
            this.dayItem = dayItems[0];
            // 获取链表数据
            this.setChainArray();
            const titleDate = this.solarDate.getYear() + "年" + this.$Utils.addZero(this.solarDate.getMonth()) + "月";
            this.submitCycle(titleDate, itemYmd);
            // 选择一天
        },

        /**
         * 获取横向链表数据
         * 获取纵向链表数据
         */
        setChainArray: function(){
            this.allDayChainItems = SetChainItems.setChainItems([this.dayItem], 2, "day");

            // 每天的小时
            const hourDayChainItem = {
                chainItems: [],
                upFoldItems: [],
                downFoldItems: [],
                dayIndex: 0,
            };
            this.hourDayChainItem = SetChainItemsHour.setChainItems([this.dayItem], [hourDayChainItem], this.upFoldIndex, this.downFoldIndex)[0];

            this.hourItems = this.$Utils.getHourItems(this.upFoldIndex, this.downFoldIndex);
        },
        toTimeHeight: function(){
            setTimeout(()=>{
                const rowScroll = this.$refs["row-scroll"];
                rowScroll.scrollTo({
                    top: (this.hourNumber - 2) * 155,
                    behavior: "smooth",
                });
            }, 500)
        },
        getRedLine:function(){
            const now = new Date();
            this.todayStr = Solar.fromDate(now).toYmd();
            const hour = now.getHours();
            const minute = now.getMinutes();
            this.lineTime = this.$Utils.addZero(hour) + ":" + this.$Utils.addZero(minute);
            this.hourNumber = hour;
            this.minuteNumber = minute;
        },

        /**
         * 鼠标 移入小时
         */
        mouseenter: function(hourIndex){
            this.mouseHourIndex = hourIndex;
        },
        /**
         * 鼠标 移出小时
         */
        mouseleave: function(){
            this.mouseHourIndex = -1;
        },
        /**
         * 点击折叠
         * 1. 显示折叠行
         * 2. 重新计算数据
         * @param hourIndex
         * @param foldAllow
         */
        setFoldIndex: function(hourIndex, foldAllow){
            if(!foldAllow){
                return
            }else if(hourIndex < 10){
                // 向上折叠 0至hourIndex
                this.upFoldIndex = hourIndex;

                const rowScroll = this.$refs["row-scroll"];
                rowScroll.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });

            }else if(hourIndex > 13){
                // 向下折叠 hourIndex 至 24点
                this.downFoldIndex = hourIndex;
            }else{
                return
            }
            this.setChainArray();

        },
        /**
         * 点击展开
         * @param foldType
         */
        setUnfoldIndex: function(foldType){

            if(foldType === "upFoldIndex"){
                this.upFoldIndex = -1;
            }else{
                this.downFoldIndex = 24;
            }
            this.setChainArray(this.dayItems);
        },
        submitCycle: function(titleDate, cycleFirstDay){
            this.$emit("cycleEvent", {
                titleDate: titleDate,
                cycleFirstDay: cycleFirstDay,
                selectDayStr: this.selectDayStr,
            });
        },
        /**
         * 打开当天事件窗口
         */
        submitDay: function(){
            this.selectDayStr = this.dayItem.date;
            this.$emit("dayEvent", this.dayItem);
        },
        submitMatter: function(matterItem){
            if(matterItem.matterItem){
                this.$emit("matterEvent", matterItem.matterItem);
            }else{
                this.submitDay();
            }
        },
    },
    mounted(){
        this.getRedLine();
        this.intervalId = setInterval(()=>{
            this.getRedLine()
        }, 5000);
        this.getCycleDayItems("current");
        this.toTimeHeight();
    },
    beforeDestroy() {
        if (this.intervalId){
            clearInterval(this.intervalId);
        }
    }
}
</script>

<style scoped>
div.body-view-day{
    width: 100%;
    height: calc(100% - 0.56rem);
}

div.items-week{
    width: 100%;
    height: 0.46rem;
    display: flex;
    box-sizing: border-box;
    border-top: #EEEEEE solid 0.01rem;
    border-bottom: #EEEEEE solid 0.01rem;
}
div.left-none{
    flex-basis: 0.8rem;
    height: 0.44rem;
    font-size: 0.12rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.44rem;
    text-align: center;
    box-sizing: border-box;
}

div.item-week{
    flex: 1;
    font-size: 0.15rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.44rem;
    text-align: center;
    box-sizing: border-box;
    border-left: #EEEEEE solid 0.01rem;
}

div.row-day{
    width: 100%;
    height: 0.9rem;
    display: flex;
    box-sizing: border-box;
    border-bottom: #EEEEEE solid 0.01rem;
    /*background: burlywood;*/
}
div.left-day{
    flex-basis: 0.8rem;
    font-size: 0.16rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.9rem;
    text-align: center;
}
div.item-all-day{
    flex: 1;
    box-sizing: border-box;
    border-left: #EEEEEE solid 0.01rem;
    background: rgba(255, 239, 180, 0.4);
}

div.item-day-title{
    width: 100%;
    display: flex;
    gap: 0.13rem;
    justify-content: center;
    align-items: center;
    height: 0.34rem;
    box-sizing: border-box;
    border-bottom: #EEEEEE solid 0.01rem;
}
div.text-day{
    width: 0.24rem;
    height: 0.24rem;
    font-size: 0.14rem;
    font-family: PF-Medium, sans-serif;
    font-weight: bold;
    text-align: center;
    color: #333333;
    line-height: 0.24rem;
    border-radius: 50%;

    /*margin: 0.05rem 0.1rem;*/
    /*display: inline-block;*/
    /*vertical-align: top;*/
}

div.text-vice-day{
    /*width: calc(100% - 0.88rem);*/
    /*height: 100%;*/
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;
    /*color: #999999;*/
    /*line-height: 0.34rem;*/
    /*display: inline-block;*/
}
div.text-work-day, div.text-rest-day{

    font-size: 0.14rem;
    font-family: PF-Medium, sans-serif;
    line-height: 0.34rem;

}
div.text-work-day{
    color: #06CE90;
}
div.text-rest-day{
    color: #E13E39;
}
div.item-day-chain{
    width: 100%;
    height: calc(100% - 0.34rem);
    /*background: lightblue;*/
}

div.chain-row{
    width: 100%;
    height: 0.24rem;
    padding: 0.01rem 0.05rem;
    box-sizing: border-box;

}
div.item-matter{
    width: 100%;
    height: 0.20rem;

    border-radius: 0.04rem;
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;

    color: #333333;
    line-height: 0.20rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    padding-left: 0.08rem;
}

div.row-scroll{
    width: 100%;
    height: calc(100% - 0.46rem - 0.9rem);
    overflow-y: auto;
}

div.row-up-fold-hour, div.row-down-fold-hour{
    width: 100%;
    height: 1rem;
    display: flex;
    box-sizing: border-box;
    border-bottom: #EEEEEE solid 0.01rem;
}
div.row-up-fold-hour div.left-hour, div.row-down-fold-hour div.left-hour{
    background: #F6F7F8;
}
div.row-hour-item{
    width: 100%;
    height: 1.55rem;
    display: flex;
    box-sizing: border-box;
    border-bottom: #EEEEEE solid 0.01rem;
}
div.left-hour{
    flex-basis: 0.8rem;
    font-size: 0.12rem;
    font-family: PF-Regular, sans-serif;
    color: rgba(51, 51, 51, 0.5);
    line-height: 0.16rem;
    text-align: center;
}
div.fold-switch{
    margin-top: 0.5rem;
}

div.item-hour-day{
    flex: 1;
    box-sizing: border-box;
    border-left: #EEEEEE solid 0.01rem;
}
div.fold-matter-text, div.fold-more-text{
    max-width: 2.5rem;
    height: 0.24rem;

    font-family: PF-Regular, sans-serif;
    font-size: 0.14rem;
    color: #333333;
    line-height: 0.24rem;
    text-align: left;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    padding: 0 0.14rem;
    box-sizing: border-box;
}

div.column-items-day{
    width: calc(100% - 0.8rem);
    /*height: calc(1.55rem * 24);*/
    /*margin-top: calc(-1.55rem * 24);*/
    margin-left: 0.8rem;
    position: relative;
    display: flex;
}
div.time-line{
    width: 100%;
    height: 0.01rem;
    z-index: 10;

    display: inline-block;
    vertical-align: top;
}
div.time-line-point{
    width: 0.1rem;
    height: 0.1rem;
    background: #E13E39;
    margin-top: -0.05rem;
    border-radius: 50%;

    display: inline-block;
    vertical-align: top;
}
div.hour-text-now{
    width: 0.45rem;
    height: 0.24rem;
    margin-top: -0.12rem;
    margin-left: -0.6rem;
    background: #000000;

    font-family: PF-Regular, sans-serif;
    font-size: 0.12rem;
    color: #FFFFFF;
    line-height: 0.24rem;
    text-align: center;
    border-radius: 0.5rem 0 0.5rem 0.5rem;

    display: inline-block;
    vertical-align: top;
}
div.column-item-day{
    width: 100%;
    display: flex;
}

div.matter-item{
    box-sizing: border-box;
    padding: 0.01rem 0.05rem;
    position: relative;

}
div.matter-text{
    width: 100%;
    height: 100%;
    border-radius: 0.04rem;
    font-size: 0.14rem;
    font-family: PF-Regular, sans-serif;
    color: #333333;
    line-height: 0.22rem;

    white-space: nowrap;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    /*text-indent: 0.08rem;*/
    box-sizing: border-box;

}
</style>